import { z } from 'zod'

// #14 - gedeelde Zod-schemas voor klant-veiligheid-inzendingen. Eén bron voor de
// API (parse) én het klant-form (client-side validatie) zodat het form niets kan
// sturen dat de API weigert.

export type ClientSafetySubmissionStatus =
  | 'WACHT_OP_GOEDKEURING'
  | 'GOEDGEKEURD'
  | 'AFGEKEURD'

// Veiligheidsregel die de klant invult (vrije tekst, geen bestand).
export const clientSafetyRuleCreateSchema = z.object({
  titel: z.string().trim().min(2).max(200),
  omschrijving: z.string().trim().min(1).max(5000),
})
export type ClientSafetyRuleCreateInput = z.infer<typeof clientSafetyRuleCreateSchema>

// Document-metadata komt als multipart-velden mee; het bestand zelf
// (mimetype/grootte) wordt door de route gevalideerd.
export const clientSafetyDocumentMetaSchema = z.object({
  titel: z.string().trim().min(2).max(200),
  omschrijving: z.string().trim().max(5000).optional(),
})
export type ClientSafetyDocumentMetaInput = z.infer<
  typeof clientSafetyDocumentMetaSchema
>

// Backoffice-beoordeling: bij AFKEUREN is een reden verplicht (min. 3 tekens).
export const clientSafetyBeoordeelSchema = z
  .object({
    besluit: z.enum(['GOEDGEKEURD', 'AFGEKEURD']),
    afwijsreden: z.string().trim().max(2000).optional(),
  })
  .refine(
    (v) =>
      v.besluit !== 'AFGEKEURD' ||
      (typeof v.afwijsreden === 'string' && v.afwijsreden.length >= 3),
    { message: 'Reden is verplicht bij afkeuren (min. 3 tekens)', path: ['afwijsreden'] },
  )
export type ClientSafetyBeoordeelInput = z.infer<typeof clientSafetyBeoordeelSchema>
